module.exports = __webpack_public_path__ + "d650b6fc940d92aa936807ce5db34d97.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/regeneron_pharmaceuticals_2023_chart.png
// module id = 1731
// module chunks = 0